import * as React from 'react';
import classNames from 'classnames';

import * as Const from '../../constants';
import toasterPickIcon from '../../utils/toasterPickIcon/tosaterPickIcon';

import toasterLineHeight from '../../utils/toasterLineHeight';

import Snackbar from '@material-ui/core/Snackbar';
import { Grid } from '@material-ui/core';

import './style.scss';

import Message from '../../interfaces/Message';

interface Props {
  removeMessage: (id: string) => void;
  message: Message;
  stepPx: number;
}
class ToasterWrapper extends React.PureComponent<Props> {

  handleDelete = () => {
    this.props.removeMessage(this.props.message.id);
  };

  render () {

    const { type, content } = this.props.message;

    const subSentWrapper = classNames('sub-message-toaster', {
      'sub-message-fail': type === Const.MESSAGE_TYPE.fail,
      'sub-message-success': type === Const.MESSAGE_TYPE.success,
      'sub-message-warning': type === Const.MESSAGE_TYPE.warning,
    });

    return (
      <Snackbar
        style={{ bottom: `${this.props.stepPx}px` }}
        // @ts-ignore
        anchorOrigin={Const.ANCHOR_ORIGIN}
        open>
        <div
          style={{ lineHeight: toasterLineHeight(content) }}
          className={subSentWrapper}>
          <Grid container>
            <Grid
              item
              sm={1}
              md={1}
              lg={1}>
              <img
                className='sub-sent-image'
                // @ts-ignore
                src={toasterPickIcon(type)}
                alt='' />
            </Grid>
            <Grid
              item
              sm={10}
              md={10}
              lg={10}>
              <div className='sub-toaster-message-title'>
                {content}
              </div>
            </Grid>

            <Grid
              item
              sm={1}
              md={1}
              lg={1} >
              <button
                className='sub-clear-btn sub-toaster-message-close'
                onClick={this.handleDelete}>
                <div className='sub-toaster-message-close-str'>
                  {'х'}
                </div>
              </button>
            </Grid>
          </Grid>
        </div>
      </Snackbar>
    );
  }
}

export default ToasterWrapper;
